module.exports = __webpack_public_path__ + "media/images/riders/small/KATE_COURTNEY-1a8e621fda012519406a5f3e763e5ea4.png";